import { colors } from './_/colors-9682f562.js';
let theme = {
    colors
};
export { theme as default };
//# sourceMappingURL=defaultTheme.js.map
